import { render } from "./ColorPreview.vue?vue&type=template&id=b0580304"
import script from "./ColorPreview.vue?vue&type=script&lang=js"
export * from "./ColorPreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__